import React, { useContext } from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { ChartsReferenceLine } from '@mui/x-charts';
import { LeaderboardContext } from '../../contexts/leaderboard-context';
import { Box, Typography } from '@mui/material';

export const LeaderboardGraph = () => {
  const { leaderboardData } = useContext(LeaderboardContext);

  if (!leaderboardData || leaderboardData.length === 0) {
    return <Typography>No leaderboard data available.</Typography>;
  }

  // Prepare data for the chart
  const series = leaderboardData.map(club => {
    let cumulativeScore = 0;
    const allScores = [...club.prevScores, club.weekScore]; // Include current week's score
    const data = allScores.map((score, index) => {
      cumulativeScore += score;
      return {
        x: index + 1, // Week number (1-based)
        y: cumulativeScore, // Cumulative total points
      };
    });
    return {
      data: data.map(point => point.y),
      label: club.clubName,
      id: club.clubId,
      showMark: true,
    };
  });

  const xAxisData = leaderboardData[0].prevScores.map((_, index) => index + 1);
  xAxisData.push(xAxisData.length + 1); // Add an extra week for the current weekScore

  return (
    <Box sx={{ width: '100%', height: 600 }}>
      <Typography variant="h6" gutterBottom>
        Club Performance Over Weeks
      </Typography>
      <LineChart
        xAxis={[{ data: xAxisData, label: 'Week Number', scaleType: 'point' }]}
        yAxis={[{ label: 'Total Points' }]}
        series={series}
        margin={{ left: 10, right: 20, top: 30, bottom: 50 }}
        grid={{ vertical: true, horizontal: true }}
        tooltip={{ trigger: 'axis' }}
        referenceLines={[
          {
            x: 3,
            label: 'Window 1',
            lineStyle: { strokeDasharray: '5 5', stroke: 'red' },
          },
        ]}
        slotProps={{
          legend: {
            position: { vertical: 'top', horizontal: 'center' },
            direction: 'horizontal',
            padding: 0,
          },
        }}
      >
        <ChartsReferenceLine
          x={3}
          label="Window 1"
          labelAlign="start"
          lineStyle={{ strokeDasharray: '5 5', stroke: 'red' }}
        />
      </LineChart>
    </Box>
  );
};
